// React
import React, { Component, createRef } from 'react';
import { findDOMNode } from 'react-dom';

// External libraries
import moment from 'moment';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Steps, Input, Row, Col, Form, message, notification, Icon } from 'antd';
import { withTranslation } from 'react-i18next';
import { ErrorBoundary } from 'react-error-boundary';

// Utilities
import { random, debounce } from 'lodash';

// Constants
import UserRoleEnum from '../../../../constants/UserRoleEnum';
import { STEP_INFO, STEP_LIBRARY, STEP_SETTINGS, STEP_SUMMARY, STEP_PAYMENT } from '../constants/steps';

// Services
import {
  getAspectRatio,
  getSimilarAspectRatio,
  getCpmByStatusCampaign,
  getSpotsPerDay,
  buildAudienceContentDisplays,
  getRelationShowDays,
  getTotalPice
} from '../../../../services/display';

import { redistributePendingShows } from '../services/showsRedistribution';

import {
  getUrl,
  hasAccessRole,
  isCampaignFinished,
  validateCharLimit,
  getRelationId
} from '../../../../services/utils';
import { checkIsNewDisplayInEdit, isApprovedPaymentStatus } from '../../../../services/campaignManager';

// Global components
import CampaignManagerHolder from '../../../../components/Styles/campaignManagerStyle';
import VerifiedAgencyInfoModal from '../../../../components/VerifiedAgencyInfoModal';
import UnderMinimumSpotsModal from '../../../../components/UnderMinimumSpotsModal';
import NewScreensWarningModal from './NewScreensWarningModal';
import OptionModal from '../../../shared/components/OptionModal';
import LeftSideComponent from '../../../../components/LeftSideComponent';
import RightSideComponent from './sidebars/RightSideComponent';
import CriticalErrorFallbackComponent from '../../../../components/ErrorFallbacks';
import NumberFormat from '../../../../components/NumberFormat';
import CheckCompanyForUserComponent from '../../../../components/CheckCompanyForUserComponent';

// Steps (local components)
import StepInfo from './step0_info';
import { isVersionFullyCovered, getRequiredVersionName, getUnmatchedVersions } from './step1_library';
import LibraryStepContainer from '../containers/LibraryStepContainer';
import StepTwo from './step2_settings';
import StepThree from './step3_checkout';
import StepFour from './step4_payment';

// Feature services
import {
  spots,
  budget,
  distribution
} from '../services/investmentCalculations';

const { Step } = Steps;

const CATEGORY_SELECT_CLASS = 'selectCategories';

// En tablet/mobile (< 1200px) los sidebars con la info de campaña van colapsados
// bajo un toggle "Información de campaña". Se recuerda la preferencia del usuario.
const SIDE_INFO_COLLAPSED_KEY = 'dsp.campaignManager.sideInfoCollapsed';

const readSideInfoCollapsed = () => {
  try {
    const stored = window.localStorage.getItem(SIDE_INFO_COLLAPSED_KEY);
    return stored === null ? true : stored === 'true';
  } catch (e) {
    return true;
  }
};

class CampaignManagerComponent extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.debouncedGetAudience = debounce(this.props.getAudience, 500);
    this.campaignNameFormRef = createRef();
    this.contentsDisplaysFormRef = createRef();
    this.contentsPanelRef = createRef();
    this.categorySelectRef = React.createRef();
  }

  state = {
    errors: {},
    sideInfoCollapsed: readSideInfoCollapsed(),
    excessTraditionalVideoLength: false,
    excessProgrammaticVideoLength: false,
    visibleClearModal: false,
    unmatchedVersionsWarning: null,
    isUnderMinimumModalVisible: false,
    generalRuleActive: false,
    rules: [{ conditions: [] }],
    arrayTime: {
      type: 'hour',
      from: '00:00',
      to: '23:59'
    },
    arrayDays: {
      type: 'day',
      value: []
    },
    canva: {},
    uploadingFile: false,
    canvaModalVisible: false,
    rulesModalVisible: false,
    width: 300,
    height: 300,
    totalShows: 0,
    totalPromisedShows: 0,
    subsidizeTotalPromisedShows: 0,
    checkNullRules: false,
    subsidized_all: false,
    inputCharLimit: {
      value: 0
    },
    areaCharLimit: {
      value: 0
    },
    arrContentChanged: [],
    isVerifiedAgencyModalVisible: false,
    verifiedAgencyModalMessage: null,
    // new videoUpload
    stepsCurrent: STEP_INFO,
    settingFilter: 'resolution',
    consumedAmountBudget: 0,
    viewCampaignPayment: false,
    viewProposal: false,
    blockCreationType: false,
    underMinimumProgrammaticSpots: [],
    creditAvailableOnTransferredImpressions: [],
    newScreensWarningVisible: false
  };

  componentWillUnmount() {
    // Clean up the campaign when it has been created.
    const { editCampaignActive, clearCampaignData, currentCampaign } = this.props;
    if (
      !editCampaignActive &&
      (this.state.stepsCurrent === STEP_SUMMARY || this.state.stepsCurrent === STEP_PAYMENT)
    )
      clearCampaignData();
    if (
      editCampaignActive &&
      isApprovedPaymentStatus(currentCampaign) &&
      this.state.stepsCurrent === STEP_SETTINGS
    )
      clearCampaignData();
  }

  componentWillReceiveProps(nextProps) {
    // Show proposal when loading proposal
    if (
      this.props.loadingProposal &&
      !nextProps.loadingProposal &&
      this.state.viewProposal &&
      nextProps.proposalToken &&
      nextProps.proposalToken.token
    ) {
      let lenguageParse;
      switch (this.props.i18n.language) {
        case 'es':
          lenguageParse = 'esLA';
          break;
        case 'es_ar':
          lenguageParse = 'es';
          break;
        default:
          break;
      }
      this.setState({
        viewProposal: false
      });
      const parameter = `lenguage=${lenguageParse || this.props.i18n.language}&token=${
        nextProps.proposalToken.token
      }`;
      window.open(getUrl(window.location, 'proposal.html', parameter));
      this.props.history.push(`/proposals`);
    }

    if (
      this.props.creatingCampaign &&
      !nextProps.creatingCampaign &&
      nextProps.campaign &&
      nextProps.campaign.id
    ) {
      if (nextProps.errors.length === 0) {
        // this.props.history.push(`/campaign/${nextProps.campaign.id}/payment`);
        this.createCampaignSuccess(nextProps.campaign);
        return;
      }
    }
  }

  resetCampaignData = () => {
    this.setState({ blockCreationType: false });
    this.props.resetCampaignData();
  };

  calculatePromisedShow = (display, countRelation) => {
    const { cart, amountBudget, programmatic, editCampaignActive, currentCampaign } = this.props;
    if (programmatic !== 'programmatic') return null;
    if (countRelation === 0) return 0;
    const budgetPerRelation = parseFloat(amountBudget) / cart.length / countRelation;
    return spots.fromBudget(
      budgetPerRelation,
      getCpmByStatusCampaign(editCampaignActive, currentCampaign, display)
    );
  };

  addRelationDisplayContent = (customContentsLength, display, contentId, promised_show, index) => {
    const { subsidized_all } = this.state;
    const usedListOfContentsInCampaign =
      this.props.creationType === 'makeProposal'
        ? this.props.listOfPlaceholdersInCampaign
        : this.props.listOfContentsInCampaign;

    const isDisplayInCampaign = this.props.customContents.filter(c => c.displayId === display.id);
    const subsidizeRelationsInDisplay = isDisplayInCampaign.every(c => c.subsidized_price === true);
    const isSecuredInvestmentInDisplay = isDisplayInCampaign.every(c => c.is_secured_investment === true);
    let relationId = display.id + '_' + (customContentsLength + random(99999999));
    const content = usedListOfContentsInCampaign.find(content => content.id === contentId);
    const isApprovedCampaign =
      this.props.editCampaignActive && isApprovedPaymentStatus(this.props.currentCampaign);
    if (isApprovedCampaign) {
      const versionAlreadyExists = isDisplayInCampaign.some(
        existingRelation => existingRelation.content && existingRelation.content.content_version_name === content.content_version_name
      );
      if (versionAlreadyExists) return;
    }
    const fullDisplay = this.props.cart.find(d => d.id === display.id) || display;
    // TO DO: Modify for update campaign
    var data = {
      relationId: relationId,
      indice_relation: index,
      active: this.props.isCampaignPaused ? 0 : 1,
      displayId: display.id,
      fill_screen: display.fill_screen,
      revision_status: content.isPlaceholder ? 'pending_content' : 'pending',
      isPendingContent: content.isPlaceholder,
      file_thumb: content.content_file,
      isContentMixed: false,
      promised_shows_subsidized: 0,
      promised_shows: promised_show,
      id: content.id,
      length: content.length || display.slot_length,
      content: { ...content },
      rules: Array.isArray(content.rules)
        ? content.rules
        : typeof content.rules === 'string' && content.rules.length > 0
        ? JSON.parse(content.rules)
        : [],
      content_version_name: content.content_version_name,
      cpm: display.cpm ? display.cpm : display.smart_campaign_cpm,
      subsidized_price:
        isDisplayInCampaign && isDisplayInCampaign.length > 0
          ? subsidizeRelationsInDisplay
          : subsidized_all,
      programmatic_volume_discount_apply: display.programmatic_volume_discount_apply
        ? display.programmatic_volume_discount_apply
        : null,
      programmatic_volume_discounts: display.programmatic_volume_discounts,
      is_secured_investment: isDisplayInCampaign && isDisplayInCampaign.length > 0 ? isSecuredInvestmentInDisplay : !!(fullDisplay.company && fullDisplay.company.secured_investment_mode),
      minimum_programmatic_spots: display.minimum_programmatic_spots || 0,
      minimum_programmatic_period: display.minimum_programmatic_period || 0
    };

    this.props.addCustomContentFromCampaign(
      data.relationId,
      data.indice_relation,
      data.active,
      data.displayId,
      data.fill_screen,
      data.revision_status,
      data.isPendingContent,
      data.isContentMixed,
      data.promised_shows,
      data.length,
      data.content,
      data.rules,
      data.subsidized_price,
      data.promised_shows_subsidized,
      content.name,
      data.cpm,
      data.programmatic_volume_discount_apply,
      data.programmatic_volume_discounts,
      data.promised_shows_discounted,
      data.is_secured_investment,
      data.minimum_programmatic_spots,
      data.minimum_programmatic_period
    );
  };

  distributeImpressionsForActiveCampaign = (customContentFilterByDisplay, totalContents, displayId) => {
    const { reportSingleData } = this.props;

    const { updates, newSlotPaid } = redistributePendingShows({
      relations: customContentFilterByDisplay,
      reportSingleData,
      displayId,
      extraSlots: totalContents - customContentFilterByDisplay.length,
      includeSubsidized: false,
    });

    const customContentFilterByDisplayAux = customContentFilterByDisplay.map((content, i) => ({
      ...content,
      promised_shows: updates[i].promised_shows,
    }));

    return [customContentFilterByDisplayAux, newSlotPaid];
  };

  // Calcule the impressions for the new relation depending of the total of contents in the display
  calculateAndApplyRelation = (
    isTheFirstApply,
    customContentFilterByDisplay,
    displayData,
    listResolution,
    index,
    foundContent,
    addNewDisplay
  ) => {
    const { realAmount, isPaymentStatusApproved } = this.props;
    let promised_show = 0;

    const inactiveExistingContents = customContentFilterByDisplay.filter(c => c.active === 0)
      .length;
    const activeRealContents = customContentFilterByDisplay.filter(
      c => c.active === 1 && !c.content.isPlaceholder
    );
    const calculatedTotalContents = Math.max(
      1,
      displayData.totalContents - inactiveExistingContents
    );

    // When campaign is active
    let [customContentFilterByDisplayAux, fullImpressions] = [];
    if (
      (!isTheFirstApply && customContentFilterByDisplay.length > 0 && !addNewDisplay) ||
      isPaymentStatusApproved
    ) {
      if (calculatedTotalContents > 1) {
        [
          customContentFilterByDisplayAux,
          fullImpressions
        ] = this.distributeImpressionsForActiveCampaign(
          customContentFilterByDisplay,
          calculatedTotalContents,
          displayData.display.id
        );

        if (fullImpressions !== undefined) {
          this.props.updatePromiseShowsInRelations(customContentFilterByDisplayAux);
        }
        promised_show = fullImpressions;
      } else if (calculatedTotalContents === 1) {
        const totalHistoricalSpots = customContentFilterByDisplay.reduce(
          (acc, c) => acc + (c.promised_shows || 0),
          0
        );
        const inactiveSpots = customContentFilterByDisplay
          .filter(c => c.active === 0)
          .reduce((acc, c) => acc + (c.promised_shows || 0), 0);
        if (totalHistoricalSpots > 0) {
          promised_show = totalHistoricalSpots - inactiveSpots;
        }
      }
    }

    // The promise show are defined with updateByAmountBudget
    if (isTheFirstApply) {
      promised_show = 0;
    }

    let indice = listResolution.contentsDisplays.length > 1 ? index : null;
    if (promised_show > 99999999999) {
      promised_show = 99999999998;
    }

    this.addRelationDisplayContent(
      displayData.totalContents,
      displayData.display,
      foundContent.id,
      promised_show,
      indice
    );
  };

  getBudgetFixed(editCampaignActive, currentCampaign, customContents) {
    return budget.sumFixed(customContents, {
      getCpm: item => {
        const display = this.props.cart.find(d => d.id === item.displayId);
        return getCpmByStatusCampaign(editCampaignActive, currentCampaign, display);
      },
      isFixed: item => item.isFixedBudget
    });
  }

  updateByAmountBudget = amountBudget => {
    const { cart, editCampaignActive, customContents, currentCampaign } = this.props;
    if (!customContents || customContents.length < 1) return;

    const updatedContents = distribution.byBudget(amountBudget, cart, customContents, {
      getCpm: display => getCpmByStatusCampaign(editCampaignActive, currentCampaign, display),
      isFixed: item => item.isFixedBudget
    });
    this.props.updatePromiseShowsInRelations(updatedContents);
  };

  // This function creates the relation between the display and the content.
  // return: contents_displays
  applyRelationOnScreens = (groupedDisplays = null, updatedListResolution = null) => {
    const {
      customContents,
      listResolutionWithContent,
      listResolutionWithPlaceholders,
      creationType
    } = this.props;
    const usedListResolution =
      creationType === 'makeProposal' ? listResolutionWithPlaceholders : listResolutionWithContent;
    const displayDataMap = {};
    const listResolutionWithContentAux = updatedListResolution
      ? updatedListResolution
      : usedListResolution;
    const isTheFirstApply = customContents.length === 0;

    // Create a map with the display data for optimization
    listResolutionWithContentAux.forEach(lr => {
      lr.displays.forEach(display => {
        const displayId = display.id;
        if (!displayDataMap[displayId]) {
          displayDataMap[displayId] = {
            display: display,
            totalContents: 0
          };
        }
        displayDataMap[displayId].totalContents += lr.contentsDisplays.reduce((count, item) => {
          return item.displayId === displayId ? count + 1 : count;
        }, 0);
      });
    });

    // Check if add new display
    let addNewDisplay = false;
    if (!groupedDisplays) {
      addNewDisplay = Object.values(displayDataMap).some(
        displayData => !customContents.some(c => c.displayId === displayData.display.id)
      );
    }

    // Iterate over listResolutionWithContent to add new relations
    listResolutionWithContentAux.forEach(listResolution => {
      if (listResolution && listResolution.contentsDisplays) {
        listResolution.contentsDisplays.forEach((contentDisplay, index) => {
          const displayData = displayDataMap[contentDisplay.displayId];
          if (
            groupedDisplays &&
            !groupedDisplays.find(display => display.id === displayData.display.id)
          ) {
            return;
          }
          const foundContent = listResolution.contents.find(
            content => content.id === contentDisplay.contentId
          );
          if (!foundContent) return;
          const customContentFilterByDisplay = customContents.filter(
            c => c.displayId === contentDisplay.displayId
          );
          const customContentFilterByContent = customContentFilterByDisplay.filter(
            c => c.content.id === foundContent.id
          );

          customContentFilterByDisplay.forEach(c => {
            this.props.togglePendingContent(c.displayId, c.relationId, c.content.isPlaceholder);
          });

          // If relation exist, update the content name
          if (customContentFilterByContent.length > 0) {
            if (customContentFilterByContent[0].content.name != foundContent.name) {
              customContentFilterByContent.forEach(c => {
                this.props.updateContentName(c.relationId, foundContent);
              });
            }
            return;
          }
          // Update the budget when add new relations
          this.calculateAndApplyRelation(
            isTheFirstApply,
            customContentFilterByDisplay,
            displayData,
            listResolution,
            index,
            foundContent,
            addNewDisplay
          );
        });
      }
    });
  };

  updateCreditAvailable = creditAvailable => {
    const { creditAvailableOnTransferredImpressions } = this.state;
    const indiceExistente = creditAvailableOnTransferredImpressions.findIndex(
      item => item.company_id === creditAvailable.company_id
    );

    if (indiceExistente !== -1) {
      creditAvailableOnTransferredImpressions[indiceExistente] = creditAvailable;
    } else {
      creditAvailableOnTransferredImpressions.push(creditAvailable);
    }
    this.setState({ creditAvailableOnTransferredImpressions });
  };

  checkMinimumProgrammaticSpots = () => {
    const { customContents, cart, isPaymentStatusApproved, programmatic } = this.props;

    // Skip validation if payment is already approved
    if (isPaymentStatusApproved || programmatic !== 'programmatic') {
      return [];
    }

    const underMinimumProgrammaticSpots = [];

    // Group contents by display
    const displayGroups = {};
    customContents.forEach(content => {
      if (!displayGroups[content.displayId]) {
        displayGroups[content.displayId] = [];
      }
      displayGroups[content.displayId].push(content);
    });

    // Check each display
    Object.keys(displayGroups).forEach(displayId => {
      const contentsForDisplay = displayGroups[displayId];
      const display = cart.find(d => d.id === parseInt(displayId));

      if (!display) return;

      const displayMinimumProgrammaticSpots = display.minimum_programmatic_spots || 0;
      const displayMinimumProgrammaticPeriod = display.minimum_programmatic_period || 0;

      // Skip if no minimum requirement
      if (displayMinimumProgrammaticSpots === 0) return;

      // Check if any content is pending
      const hasPendingContent = contentsForDisplay.some(
        content =>
          content.revision_status === 'pending_content' || content.revision_status === 'pending'
      );

      if (!hasPendingContent) return;

      // Calculate total spots per day for this display (sum of all contents)
      const totalSpotsPerDay = contentsForDisplay.reduce((total, content) => {
        const spotsPerDay = getSpotsPerDay(content, this.props.date_from, this.props.date_to);
        return total + spotsPerDay;
      }, 0);

      // Get campaign days from first content
      const firstContent = contentsForDisplay[0];
      const campaignDays = getRelationShowDays(
        this.props.date_from,
        this.props.date_to,
        firstContent.rules
      );

      // Check if it's daily or total period validation
      if (displayMinimumProgrammaticPeriod === 0) {
        // Daily validation
        if (totalSpotsPerDay < displayMinimumProgrammaticSpots) {
          // Add grouped display info with all contents
          underMinimumProgrammaticSpots.push({
            displayId: parseInt(displayId),
            display: display,
            contents: contentsForDisplay,
            totalSpotsPerDay: totalSpotsPerDay,
            campaignDays: campaignDays,
            validationType: 'daily'
          });
        }
      } else {
        // Total period validation
        const totalSpots = totalSpotsPerDay * campaignDays;
        const minimumSpotsPeriod =
          displayMinimumProgrammaticSpots * displayMinimumProgrammaticPeriod;

        if (totalSpots < minimumSpotsPeriod) {
          // Add grouped display info with all contents
          underMinimumProgrammaticSpots.push({
            displayId: parseInt(displayId),
            display: display,
            contents: contentsForDisplay,
            totalSpotsPerDay: totalSpotsPerDay,
            totalSpots: totalSpots,
            campaignDays: campaignDays,
            validationType: 'total'
          });
        }
      }
    });

    this.setState({ underMinimumProgrammaticSpots });
    return underMinimumProgrammaticSpots;
  };

  submitCampaign = () => {
    //Create campaing
    if (!this.props.editCampaignActive) {
      this.createCampaign();
    }

    if (this.props.creationType === 'makeProposal' && !this.props.editCampaignActive) return;
  };

  isPlaceholderListOutdated = () => {
    const { creationType, cart, listResolutionWithPlaceholders } = this.props;
    if (creationType !== 'makeProposal') return false;
    const cartDisplayIds = new Set(cart.map(cartDisplay => cartDisplay.id));
    const displayIdsWithPlaceholder = new Set();
    const displayIdsInPlaceholderList = new Set();
    listResolutionWithPlaceholders.forEach(resolutionGroup => {
      resolutionGroup.displays.forEach(resolutionDisplay =>
        displayIdsInPlaceholderList.add(resolutionDisplay.id)
      );
      resolutionGroup.contentsDisplays.forEach(contentDisplay => {
        displayIdsWithPlaceholder.add(contentDisplay.displayId);
        displayIdsInPlaceholderList.add(contentDisplay.displayId);
      });
    });
    const hasNewScreensWithoutPlaceholder = [...cartDisplayIds].some(
      displayId => !displayIdsWithPlaceholder.has(displayId)
    );
    const hasRemovedScreensInPlaceholderList = [...displayIdsInPlaceholderList].some(
      displayId => !cartDisplayIds.has(displayId)
    );
    return hasNewScreensWithoutPlaceholder || hasRemovedScreensInPlaceholderList;
  };

  isNewProposalCreation = () =>
    this.props.creationType === 'makeProposal' && !this.props.editCampaignActive;

  hasNewScreensInEdit = () => {
    const { editCampaignActive, currentCampaign, cart, initialBackup, hasInitialBackup } = this.props;
    if (!editCampaignActive || !isApprovedPaymentStatus(currentCampaign)) return false;
    return cart.some(item => checkIsNewDisplayInEdit(item.id, initialBackup, hasInitialBackup));
  };

  nextSteps = () => {
    if (!this.isSubmitOk()) {
      return;
    }

    if (this.state.stepsCurrent == STEP_INFO) {
      if (this.isUnverifiedMediaCompanyTraditionalBlock()) {
        this.showVerifiedAgencyModal(this.props.t('Unverified media company traditional limit'));
        return;
      }
      this.setState({ blockCreationType: true });
    }

    if (this.state.stepsCurrent == STEP_LIBRARY) {
      if (this.isUnverifiedMediaCompanyTraditionalBlock()) {
        this.showVerifiedAgencyModal(this.props.t('Unverified media company traditional limit'));
        return;
      }

      const unmatchedVersions = getUnmatchedVersions(
        this.props.listOfContentsInCampaign,
        this.props.listResolutionWithContent
      );

      if (unmatchedVersions.length > 0) {
        this.setState({ unmatchedVersionsWarning: unmatchedVersions });
        return;
      }

      this.advanceFromLibraryStep();
      return;
    }

    if (this.state.stepsCurrent == STEP_SETTINGS) {
      if (this.isUnverifiedMediaCompanyTraditionalBlock()) {
        this.showVerifiedAgencyModal(this.props.t('Unverified media company traditional limit'));
        return;
      }

      const underMinimumProgrammaticSpots = this.checkMinimumProgrammaticSpots();

      if (underMinimumProgrammaticSpots.length > 0) {
        this.setState({ isUnderMinimumModalVisible: true });
        return;
      }

      if (this.checkUnverifiedMediaCompanyProgrammaticLimit()) {
        return;
      }

      this.calculatePrices();

      return;
    }

    const stepsCurrent = this.state.stepsCurrent + 1;
    this.setState({ stepsCurrent });
  };

  advanceFromLibraryStep = () => {
    this.applyRelationOnScreens();
    this.setState({ blockCreationType: true });

    if (this.hasNewScreensInEdit()) {
      this.setState({ newScreensWarningVisible: true });
    }

    const stepsCurrent = this.state.stepsCurrent + 1;
    this.setState({ stepsCurrent });
  };

  confirmUnmatchedVersionsWarning = () => {
    this.setState({ unmatchedVersionsWarning: null });
    this.advanceFromLibraryStep();
  };

  cancelUnmatchedVersionsWarning = () => {
    this.setState({ unmatchedVersionsWarning: null });
  };

  prevSteps = () => {
    const { currentCampaign } = this.props;
    if (this.state.stepsCurrent === STEP_INFO) {
      this.applyRelationOnScreens();
      this.props.history.push('/map');
    }
    if (this.state.stepsCurrent != STEP_INFO) {
      this.checkSubsidizedPrice();
    }
    if (this.state.stepsCurrent === STEP_PAYMENT) {
      this.props.activateEditCampaign(currentCampaign);
    }

    if (this.state.stepsCurrent === STEP_SETTINGS && this.isNewProposalCreation()) {
      this.autoAdvancingLibraryStep = false;
      this.setState({ stepsCurrent: STEP_INFO });
      return;
    }

    const stepsCurrent = this.state.stepsCurrent - 1;
    this.setState({ stepsCurrent });
  };

  hasAccessIsPauseCampaign = allDisplaysAreOwn => {
    const { user, editCampaignActive, currentCampaign } = this.props;
    const isFinished = isCampaignFinished(currentCampaign && currentCampaign.end_date);
    if (isFinished) return false;
    return (
      editCampaignActive &&
      currentCampaign.payment_status !== 'pending' &&
      this.props.currentCampaign.payment_status !== 'cancelled' &&
      currentCampaign.status !== 'proposal' &&
      user &&
      (hasAccessRole(user.roles, [UserRoleEnum.superAdmin, UserRoleEnum.superModeratorAgency]) ||
        allDisplaysAreOwn)
    );
  };

  handleErrorFocus = errorKey => {
    const refMap = {
      campaignName: this.campaignNameFormRef,
      contentsDisplays: this.contentsPanelRef,
      categories: this.categorySelectRef
    };

    const ref = refMap[errorKey];
    if (ref && ref.current) {
      const domNode = findDOMNode(ref.current);
      if (domNode) {
        domNode.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

        if (errorKey === 'campaignName') {
          const inputElement = domNode.querySelector('input');
          if (inputElement) {
            setTimeout(() => {
              inputElement.focus();
            }, 500);
          }
        }
      }
    }
  };

  validateCategories = () => {
    if (!this.props.categoriesId) {
      this.setState({
        categoryError: this.props.t('You must select a category')
      });
      return false;
    }
    return true;
  };

  isSubmitOk() {
    const { listResolutionWithContent, listResolutionWithPlaceholders, listOfContentsInCampaign, creationType } = this.props;
    const { stepsCurrent } = this.state;
    const errors = {};
    if (stepsCurrent === STEP_LIBRARY) {
      if (!this.props.editCampaignActive && !this.props.creationType) {
        errors['creationType'] = this.props.t('You must select a option');
      }
      if (
        (creationType !== 'makeProposal' &&
          !isVersionFullyCovered(listResolutionWithContent, getRequiredVersionName(listOfContentsInCampaign))) ||
        this.isPlaceholderListOutdated()
      ) {
        errors['contentsDisplays'] = this.props.t('All screens must have at least some content');
      }
    }
    if (stepsCurrent === STEP_INFO) {
      if (!this.props.editCampaignActive && !this.props.creationType) {
        errors['creationType'] = this.props.t('You must select a option');
      }
      if (!this.props.campaignName) {
        errors['campaignName'] = this.props.t('Can not be blank');
      }
      if (!this.props.categoriesId) {
        errors['categories'] = this.props.t('You must select a category');
        setTimeout(() => {
          if (this.categorySelectRef.current) {
            this.categorySelectRef.current
              .querySelector(`.${CATEGORY_SELECT_CLASS}`)
              .scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
          }
        }, 100);
      }

      const firstError = Object.keys(errors)[0];
      if (firstError) {
        this.handleErrorFocus(firstError);
      }
    }
    if (stepsCurrent === STEP_SETTINGS) {
      // Check that rules isn't null for day
      this.checkNullRules = false;
      this.props.customContents.map(content => {
        if (content.rules) {
          content.rules.map(rule => {
            if (rule.conditions.find(condition => condition.type === 'day').value.length < 1) {
              errors['rules'] = 'Problem with rules';
              return;
            }
          });
        }
      });
    }
    this.setState({ errors });
    if (Object.keys(errors).length > 0) {
      return false;
    }
    return true;
  }

  showVideoModal = () => {
    this.setState({ visibleVideoModal: !this.state.visibleVideoModal });
  };

  buildCampaignObject = () => {
    const {
      campaignName,
      isCampaignTest,
      date_from,
      date_to,
      client,
      brand,
      campaignDescription,
      categoriesId,
      currency,
      invoiceIssuingCountry,
      listBundle,
      dsp,
      customContents,
      programmatic,
      defaultRules,
      toleranceResolution,
      creationType,
      amountBudget,
      realAmount,
      cart,
      editCampaignActive,
      currentCampaign
    } = this.props;

    const makingProposal = creationType === 'makeProposal';
    const mainContent =
      customContents && customContents.length > 0 ? customContents[0].content : null;

    const contentsDisplays = (customContents || []).map(content => {
      const originalDisplay = cart.find(d => d.id === content.displayId) || {};
      const contentData = content.content || {};

      return {
        ...originalDisplay,
        display_id: content.displayId,
        display_name: originalDisplay.name,
        display_latitude: originalDisplay.latitude,
        display_longitude: originalDisplay.longitude,
        display_location_type: originalDisplay.location_type,
        display_open_ooh_venue_type_id: originalDisplay.open_ooh_venue_type_id,
        display_company_id: originalDisplay.company ? originalDisplay.company.id : null,
        content_id: makingProposal ? null : contentData.id,
        subsidized_price: content.subsidized_price || false,
        promised_shows_subsidized: content.promised_shows_subsidized || 0,
        fill_screen: content.fill_screen || false,
        promised_shows:
          content.promised_shows && programmatic === 'programmatic' ? content.promised_shows : null,
        rules: content.rules || defaultRules,
        content_name: contentData.name,
        content_file: contentData.file_thumb || contentData.file,
        content_version_name: contentData.content_version_name,
        placeholder_size: makingProposal ? contentData.placeholder_size : null,
        revision_status: content.isPendingContent ? 'pending_content' : content.revision_status,
        paid_amount_with_profit:
          programmatic === 'programmatic'
            ? (content.promised_shows *
                (getCpmByStatusCampaign(editCampaignActive, currentCampaign, originalDisplay) ||
                  0)) /
              1000
            : originalDisplay.price_per_day || 0,
        is_secured_investment: content.is_secured_investment || false
      };
    });

    return {
      id: null,
      name: campaignName || 'Nueva Campaña',
      is_test: isCampaignTest ? 1 : 0,
      active: 1,
      start_date: date_from,
      end_date: date_to,
      client: client || {},
      brand: brand || {},
      description: campaignDescription,
      tolerance_resolution: toleranceResolution,
      content_category_id: categoriesId,
      currency: currency || 'ARS',
      invoice_issuing: { alpha_2_code: invoiceIssuingCountry },
      invoice_issuing_country: invoiceIssuingCountry,
      bundles: listBundle,
      external_dsp_id: dsp ? dsp.id : null,
      main_content_id: makingProposal ? 0 : mainContent ? mainContent.id : null,
      smart_campaign: programmatic === 'programmatic',
      contents_displays: contentsDisplays,
      contents_displays_total: contentsDisplays.length,
      total_price_with_profit: programmatic === 'programmatic' ? amountBudget : realAmount,
      new_ssp: true,
      status: makingProposal ? 'proposal' : null
    };
  };

  createCampaign = () => {
    return this.props.createCampaign(this.getCreationPayload());
  };

  editCampaign = () => {
    if (!this.isSubmitOk()) {
      return;
    }
    const { id, ...payload } = this.getEditingPayload();
    return this.props.editCampaign(id, payload);
  };

  getCreationPayload = () => {
    const {
      campaignName,
      isCampaignTest,
      date_from,
      date_to,
      client,
      brand,
      campaignDescription,
      categoriesId,
      currency,
      invoiceIssuingCountry,
      listBundle,
      dsp,
      customContents,
      programmatic,
      defaultRules,
      toleranceResolution,
      creationType,
      isGuaranteed,
      selectedProposalId
    } = this.props;

    const makingProposal = creationType === 'makeProposal';
    const mainContent =
      customContents && customContents.length > 0 ? customContents[0].content : null;

    return {
      name: campaignName,
      is_test: isCampaignTest ? 1 : 0,
      active: 1,
      start_date: date_from,
      end_date: date_to,
      client: client ? client.id : null,
      brand: brand ? brand.id : null,
      description: campaignDescription,
      tolerance_resolution: toleranceResolution,
      content_category_id: categoriesId,
      currency: currency,
      invoice_issuing_country: invoiceIssuingCountry,
      bundles: listBundle,
      external_dsp_id: dsp ? dsp.id : null,
      main_content_id: makingProposal ? 0 : mainContent ? mainContent.id : null,
      smart_campaign: programmatic === 'programmatic',
      is_guaranteed: isGuaranteed,
      proposal_ai_campaign_planner_run_id: selectedProposalId || null,
      contents_displays: customContents.map(content => ({
        display_id: content.displayId,
        content_id: makingProposal ? null : content.content ? content.content.id : null,
        subsidized_price: content.subsidized_price || false,
        promised_shows_subsidized: content.promised_shows_subsidized || 0,
        fill_screen: content.fill_screen || false,
        promised_shows:
          content.promised_shows && programmatic === 'programmatic' ? content.promised_shows : null,
        rules: content.rules || defaultRules,
        content_name: content.content ? content.content.name : '',
        content_version_name: content.content ? content.content.content_version_name : '',
        placeholder_size:
          makingProposal && content.content ? content.content.placeholder_size : null,
        revision_status: content.isPendingContent ? 'pending_content' : content.revision_status,
        is_secured_investment: content.is_secured_investment || false,
      })),
      new_ssp: true,
      status: makingProposal ? 'proposal' : null
    };
  };

  getEditingPayload = () => {
    const {
      campaignName,
      isCampaignTest,
      date_from,
      date_to,
      client,
      brand,
      campaignDescription,
      toleranceResolution,
      categoriesId,
      listBundle,
      dsp,
      currentCampaign,
      customContents,
      programmatic,
      campaignCurrency,
      countries,
      campaignInvoiceIssuingCountry,
      defaultRules,
      isGuaranteed
    } = this.props;

    const searchedInvoiceIssuingCountry = countries.find(
      country => country.alpha_2_code === campaignInvoiceIssuingCountry
    );
    const mainContent = customContents.find(content => !content.isPendingContent) || null;
    const mainContentId = mainContent ? mainContent.content.id : null;

    return {
      id: currentCampaign.id,
      name: campaignName,
      is_test: isCampaignTest,
      start_date: date_from,
      end_date: date_to,
      client: client.id,
      brand: brand.id,
      description: campaignDescription,
      tolerance_resolution: toleranceResolution,
      content_category_id: categoriesId,
      bundles: listBundle,
      external_dsp_id: dsp ? dsp.id : null,
      main_content_id: currentCampaign.status === 'proposal' ? null : mainContentId,
      smart_campaign: programmatic === 'programmatic',
      is_guaranteed: isGuaranteed,
      currency: campaignCurrency,
      invoice_issuing_country: searchedInvoiceIssuingCountry,
      invoice_issuing_country_id: searchedInvoiceIssuingCountry
        ? searchedInvoiceIssuingCountry.id
        : null,
      contents_displays: customContents.map(content => {
        const revisionStatus = content.isPendingContent
          ? 'pending_content'
          : !content.isPendingContent && content.revision_status === 'pending_content'
          ? 'pending'
          : content.revision_status;

        return {
          display_id: content.displayId,
          active: content.active,
          placeholder_size: content.content.placeholder_size
            ? content.content.placeholder_size
            : null,
          content_version_name: content.content.content_version_name,
          relation_id:
            content.relationId.toString().search(content.displayId + '_') === 0
              ? null
              : getRelationId(content.relationId),
          content_id: content.content.placeholder_size ? null : content.content.id,
          fill_screen: content && content.fill_screen ? content.fill_screen : false,
          promised_shows:
            content.promised_shows !== undefined &&
            content.promised_shows !== null &&
            programmatic === 'programmatic'
              // ? content.promised_shows + (content.promised_shows_subsidized || 0)
              ? content.promised_shows
              : null,
          rules: content && content.rules ? content.rules : defaultRules,
          subsidized_price: content.subsidized_price ? content.subsidized_price : false,
          promised_shows_subsidized: content.promised_shows_subsidized
            ? content.promised_shows_subsidized
            : 0,
          content_name: content.content.name,
          ...(revisionStatus === 'pending' || revisionStatus === 'pending_content'
            ? { revision_status: revisionStatus }
            : {}),
          is_secured_investment: content.is_secured_investment || false,
        };
      })
    };
  };

  calculatePrices = () => {
    const { editCampaignActive, calculatePrices } = this.props;
    const campaignData = editCampaignActive ? this.getEditingPayload() : this.getCreationPayload();
    return calculatePrices(campaignData);
  };

  handleNameChange(e) {
    this.props.setCampaignName(e.target.value);
    this.setState({
      errors: {},
      inputCharLimit: {
        ...validateCharLimit(
          e.target.value.length,
          40,
          this.props.t('You reached the character limit!')
        ),
        value: e.target.value.length
      }
    });
    validateCharLimit();
  }

  handleDescriptionChange(e) {
    this.props.setCampaignDescription(e.target.value);
    this.setState({
      areaCharLimit: {
        ...validateCharLimit(
          e.target.value.length,
          200,
          this.props.t('You reached the character limit!')
        ),
        value: e.target.value.length
      }
    });
    validateCharLimit();
  }

  handleIsCampaignsTestToggle = isCampaignTest => {
    this.props.setIsCampaignTest(isCampaignTest);
  };

  handleIsCampaignsPausedToggle = isCampaignPaused => {
    this.props.setIsCampaignPaused(isCampaignPaused);
    if (this.props.editCampaignActive) this.props.setActive(isCampaignPaused);
  };

  isPaused = () => {
    if (!this.props.customContents || this.props.customContents.length === 0) return;

    const isPause = this.props.customContents.every(content => content.active === 0);

    if (!isPause) return;
    this.props.setIsCampaignPaused(isPause);
  };

  showClearCampaignDataModal = () => {
    this.setState({
      visibleClearModal: true
    });
  };

  hideClearCampaignDataModal = () => {
    this.setState({
      visibleClearModal: false
    });
  };

  checkUpdateByAmountBudget(amount) {
    const normalizedAmount = budget.normalize(amount);
    
    this.props.updateRealAmount(normalizedAmount);
  }

  showVerifiedAgencyModal = (message = null) => {
    this.setState({ isVerifiedAgencyModalVisible: true, verifiedAgencyModalMessage: message });
  };

  hideVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: false, verifiedAgencyModalMessage: null });
  };

  checkUnverifiedMediaCompanyProgrammaticLimit = () => {
    const { user, cart, customContents, conversionRates, currency, programmatic, t } = this.props;
    if (programmatic !== 'programmatic') return false;
    if (!user || !user.company || user.company.type !== 'media' || user.company.is_verified) return false;
    const userCompanyId = user.company_id != null ? user.company_id : (user.company && user.company.id);
    const isExternalDisplay = (display) => {
      const displayCompanyId = display.company_id ? display.company_id : display.company && display.company.id;
      if (displayCompanyId == userCompanyId) return false;
      const displayHoldingId = display.holding_id ? display.holding_id : display.company && display.company.holding_id;
      const isHoldingDisplay = user.roles && user.roles.includes('holding-member') && user.holding && user.holding.id === displayHoldingId;
      return !isHoldingDisplay;
    };
    const hasExternalScreens = cart && cart.some(isExternalDisplay);
    if (!hasExternalScreens) return false;
    const conversionRate = conversionRates && conversionRates.find(r => r.currency === (currency || 'USD'));
    const rate = conversionRate ? conversionRate.rate : 1;
    const maxBudget = 5000 * rate;
    const externalInvestment = (customContents || []).reduce((total, content) => {
      const display = (cart || []).find(d => d.id === content.displayId);
      if (!display) return total;
      if (!isExternalDisplay(display)) return total;
      const cpm = display.smart_campaign_cpm || 0;
      return total + ((content.promised_shows || 0) * cpm / 1000);
    }, 0);
    if (externalInvestment > maxBudget) {
      this.showVerifiedAgencyModal(t('Unverified media company programmatic limit'));
      return true;
    }
    return false;
  };

  isUnverifiedMediaCompanyTraditionalBlock = () => {
    const { user, cart, date_from, date_to, programmatic } = this.props;
    if (programmatic !== 'traditional') return false;
    if (!user || !user.company || user.company.type !== 'media' || user.company.is_verified) return false;
    const userCompanyId = user.company_id != null ? user.company_id : (user.company && user.company.id);
    const hasExternalScreens = cart && cart.some(display => {
      const displayCompanyId = display.company_id ? display.company_id : display.company && display.company.id;
      if (displayCompanyId == userCompanyId) return false;
      const displayHoldingId = display.holding_id ? display.holding_id : display.company && display.company.holding_id;
      const isHoldingDisplay = user.roles && user.roles.includes('holding-member') && user.holding && user.holding.id === displayHoldingId;
      return !isHoldingDisplay;
    });
    if (!hasExternalScreens) return false;
    return moment(date_to).diff(moment(date_from), 'days') >= 7;
  };

  toggleSideInfo = () => {
    this.setState(prev => {
      const sideInfoCollapsed = !prev.sideInfoCollapsed;
      try {
        window.localStorage.setItem(SIDE_INFO_COLLAPSED_KEY, String(sideInfoCollapsed));
      } catch (e) {
        // sin storage disponible: solo estado en memoria
      }
      return { sideInfoCollapsed };
    });
  };

  // Resumen de una línea para el toggle de info en tablet/mobile:
  // presupuesto · fechas · cantidad de pantallas
  renderSideInfoSummary() {
    const { t, i18n, cart, programmatic, amountBudget, currency, date_from, date_to } = this.props;
    const budgetCurrency = cart[0] && cart[0].price_currency ? cart[0].price_currency : currency;
    const budgetValue =
      programmatic === 'programmatic'
        ? Number(amountBudget)
        : getTotalPice(cart, date_from, date_to);
    const dateFormat = i18n.language === 'en' ? 'MM/DD/YY' : 'DD/MM/YY';
    const screens = cart ? cart.length : 0;
    return (
      <span className="sideInfoToggleSummary">
        <span>
          <NumberFormat value={budgetValue || 0} currency={budgetCurrency} />
        </span>
        <span>
          {moment(date_from).format(dateFormat)} → {moment(date_to).format(dateFormat)}
        </span>
        <span>
          {screens} {t('Screens').toLowerCase()}
        </span>
      </span>
    );
  }

  hideUnderMinimumModal = () => {
    this.setState({ isUnderMinimumModalVisible: false });
  };

  handleIgnoreUnderMinimum = () => {
    this.setState({
      isUnderMinimumModalVisible: false,
      underMinimumProgrammaticSpots: []
    });
    this.calculatePrices();
  };

  loadContentInCampaign = () => {
    const seenIds = new Set();
    const listContent = this.props.customContents
      .filter(content => {
        const id = content.content.id;
        if (seenIds.has(id)) return false;
        seenIds.add(id);
        return true;
      })
      .map(content => {
        return {
          ...content.content,
          isPlaceholder: content.revision_status === 'pending_content'
        };
      });

    this.props.setListOfContentsInCampaign(listContent);
  };

  checkSubsidizedPrice = () => {
    const { customContents } = this.props;
    const allSubsidized =
      customContents.length > 1
        ? customContents.every(item => item.subsidized_price === true)
        : false;
    this.setState({
      subsidized_all: allSubsidized
    });
  };

  componentDidMount() {
    const {
      user,
      cart,
      history,
      setShouldPromptLogin,
      reportSingleData,
      currentCampaign,
      editCampaignTotalPromisedShows,
      editCampaignActive,
      payments,
      setCreationType,
      resetPlaceholders,
      getCampaignRequest
    } = this.props;

    const params = new URLSearchParams(window.location.search);
    const campaignPayment = params.get('campaignPayment');
    if (campaignPayment) {
      this.setState({ stepsCurrent: STEP_PAYMENT, viewCampaignPayment: true }, () => {
        this.props.getCampaignRequest(campaignPayment);
      });
    }

    if (!user) {
      history.push('/');
      setShouldPromptLogin(true, '/');
    } else if (cart.length === 0 && !campaignPayment) {
      history.push('/map');
    }

    let totalShows = 0;
    if (reportSingleData && reportSingleData.report) {
      totalShows = reportSingleData.report.reduce((acc, display) => {
        return acc + display.shows;
      }, 0);
      this.setState({ totalShows: totalShows });
    }

    let totalPromisedShows = 0;
    let subsidizeTotalPromisedShows = 0;
    if (currentCampaign && currentCampaign.contents_displays) {
      currentCampaign &&
        currentCampaign.contents_displays.forEach(function(content_display) {
          totalPromisedShows = totalPromisedShows + content_display.promised_shows;
          subsidizeTotalPromisedShows =
            subsidizeTotalPromisedShows + content_display.promised_shows_subsidized;
        });
    }

    this.setState({ totalPromisedShows: totalPromisedShows });
    this.setState({ subsidizeTotalPromisedShows: subsidizeTotalPromisedShows });
    editCampaignTotalPromisedShows(totalPromisedShows);

    const { from } = this.props.location.state || {};

    // Setting the relation when update campaign
    if (this.props.editCampaign && from !== 'map' && this.props.listOfContentsInCampaign.length === 0) {
      this.loadContentInCampaign();
      this.checkSubsidizedPrice();
    }

    if (this.props.editCampaignActive) {
      this.props.getCampaignPayments(currentCampaign.id);
    }

    if (!this.props.categories || this.props.categories.length === 0) {
      this.props.getCategories();
    }

    setCreationType(null);
    this.setState({ blockCreationType: false });
    resetPlaceholders();
  }

  createCampaignSuccess = campaign => {
    const makingProposal = this.props.creationType === 'makeProposal';

    const message = makingProposal
      ? this.props.t('Proposal successfully created')
      : this.props.t('Campaign successfully created');
    const description = makingProposal
      ? null
      : this.props.t('You can see it in the My campaigns section.');

    notification.success({
      message: message,
      description: description,
      duration: 8,
      placement: 'topRight'
    });

    if (makingProposal) {
      this.setState({
        viewProposal: true
      });
      this.props.getProposalRequest({
        campaign_id: campaign.id
      });
    } else {
      this.props.getCampaignRequest(campaign.id);
      this.setState({
        stepsCurrent: STEP_PAYMENT,
        viewCampaignPayment: true
      });
    }
  };

  editCampaignSuccess = placement => {
    notification.success({
      message: this.props.t('Campaign successfully edited'),
      description: this.props.t('You can review it from this section before generating a payment.'),
      duration: 8,
      placement
    });

    if (!this.props.isPaymentStatusApproved) {
      if (this.props.currentCampaign && this.props.currentCampaign.id) {
        this.props.getCampaignRequest(this.props.currentCampaign.id);
      }

      this.setState({
        stepsCurrent: STEP_PAYMENT,
        viewCampaignPayment: true
      });
    }
  };

  // Define is necesary call getAudience
  changedDataOrRules = nextProps => {
    let { date_from, date_to, customContents, audience, displays } = this.props;
    if (audience.displays_with_audience && audience.displays_with_audience.length === 0)
      return false;
    //upload file
    if (nextProps.customContents === customContents) return false;

    //newContent
    if (
      customContents &&
      nextProps.customContents &&
      customContents.length !== nextProps.customContents.length
    ) {
      let lastContent = nextProps.customContents[nextProps.customContents.length - 1];
      if (!lastContent) return false;
      if (!displays.some(display => display.id === lastContent.displayId)) return false;
      return true;
    }

    let arrContentChanged = [];
    arrContentChanged = customContents.filter((content, key) => {
      const lengthRulesCurrent = content && content.rules && content.rules.length;
      const lengthRulesNext =
        nextProps.customContents[key] &&
        nextProps.customContents[key].rules &&
        nextProps.customContents[key].rules.length;
      //compare changes in promised_show/impacts
      if (
        nextProps.customContents[key] &&
        content.promised_shows !== nextProps.customContents[key].promised_shows
      )
        return true;
      //new rules
      if (lengthRulesCurrent === 0 && lengthRulesNext === 1) return true;
      //compare changes in rules
      if (
        lengthRulesCurrent > 0 &&
        (nextProps.customContents[key] && nextProps.customContents[key].rules) !== content.rules
      ) {
        //change on this screen?
        if (!displays.some(display => display.id === content.displayId)) return false;
        //have audience?
        if (audience.displays_with_no_audience.some(display => display.id === content.displayId))
          return false;
        return true;
      }
      return false;
    });

    // Save relation in state that modify for then check audience
    if (arrContentChanged.length > 0) {
      this.setState({ arrContentChanged });
      return true;
    }

    if (nextProps.date_from !== date_from) return true;
    if (nextProps.date_to !== date_to) return true;
    return false;
  };

  getAudience(props) {
    let { date_from, date_to, customContents, programmatic, dsp } = props;
    let customContents_aux = customContents;
    if (this.props.programmatic === 'traditional') {
      customContents_aux = customContents.map(content => ({ ...content, promised_shows: null }));
    } else {
      const { cart, editCampaignActive, currentCampaign } = this.props;
      customContents_aux = buildAudienceContentDisplays(
        customContents,
        cart,
        date_from,
        date_to,
        editCampaignActive,
        currentCampaign
      );
    }
    const getAudienceData = {
      _method: 'GET',
      start_date: date_from,
      end_date: date_to,
      content_displays: customContents_aux,
      type: programmatic,
      external_dsp_id: dsp && programmatic == 'programmatic' ? props.dsp.id : null
    };

    this.debouncedGetAudience(getAudienceData);
  }

  componentDidUpdate(prevProps, prevState) {
    const nextProps = this.props;
    const { currentCampaign } = nextProps;

    if (
      this.state.stepsCurrent === STEP_LIBRARY &&
      this.isNewProposalCreation() &&
      !this.autoAdvancingLibraryStep &&
      !nextProps.fetchingCampaign &&
      !nextProps.loadingContentsbyCompany &&
      !nextProps.fetchingPlaceholders &&
      (nextProps.listResolutionWithPlaceholders || []).length > 0
    ) {
      this.autoAdvancingLibraryStep = true;
      this.nextSteps();
    }

    // Update audience when customContents is updated
    if (
      this.changedDataOrRules(prevProps) &&
      !nextProps.loadingAudience &&
      !prevProps.loadingAudience
    ) {
      this.getAudience(nextProps);
    }

    const { categoriesId, categories, setCategoriesId } = this.props;

    if (
      categories.length > 0 &&
      Array.isArray(categoriesId) &&
      categoriesId.length > 0 &&
      !parseInt(categoriesId[0])
    ) {
      const foundCategory = categories.find(c =>
        c.name_en.toLowerCase().includes(categoriesId[0].toLowerCase())
      );
      if (foundCategory) {
        setCategoriesId(foundCategory.id);
      }
    }

    if (!prevProps.editCampaign && this.props.editCampaign) this.loadContentInCampaign();

    // This case is when the user is in the second step, dependent of the state of the campaign the user can go to the third step
    if (prevProps.editingCampaign !== nextProps.editingCampaign && !nextProps.editingCampaign) {
      if (nextProps.errors.length === 0) {
        if (this.state.stepsCurrent === STEP_SUMMARY) {
          this.editCampaignSuccess('topRight');
          if (!this.props.isPaymentStatusApproved && this.props.payments.length === 0) {
            return;
          }
          this.props.editCampaignInactive();
          nextProps.history.push(`/campaign/${nextProps.campaign.id}`);
          return;
        }
      }

      if (nextProps.errors && nextProps.errors.length > 0) {
        const firstError = nextProps.errors[0];
        if (
          firstError.contents_displays &&
          firstError.contents_displays[0] === 'The contents displays field is required.'
        ) {
          message.error(
            this.props.t(
              'You have not selected screens, you can go back to the map and do it from there.'
            )
          );
        } else if (firstError.message) {
          message.error(firstError.message);
        } else {
          message.error(this.props.t('An error occurred, please try again'));
        }
      }
    }

    if (nextProps.listResolutionWithContent !== prevProps.listResolutionWithContent) {
      if (prevState.errors && prevState.errors.contentsDisplays) {
        this.isSubmitOk();
      }
    }

    if (
      nextProps.errors &&
      nextProps.errors.length > 0 &&
      nextProps.errors[0] === 'Token has expired'
    ) {
      message.error(this.props.t('Token expired, please login again'), 6);
      this.props.history.push('/');
      this.props.logout();
    }

    if (
      nextProps.customContents !== prevProps.customContents &&
      this.props.programmatic === 'programmatic'
    ) {
      const isInitialLoad = prevProps.customContents.length < 1;

      if (
        nextProps.customContents &&
        nextProps.customContents.length > 0 &&
        !isInitialLoad &&
        !nextProps.isPaymentStatusApproved
      ) {
        // Only recalculate realAmount for user-triggered changes, not on initial load.
        // Approved campaigns skip this: their realAmount is managed by addNewDisplay and useInvestmentManager.
        let calculatedBudget = nextProps.customContents.reduce((acc, display) => {
          const displayAux = this.props.cart.find(d => d.id === display.displayId);
          if (!displayAux) return acc;
          const display_cpm = getCpmByStatusCampaign(
            nextProps.editCampaignActive,
            nextProps.currentCampaign,
            displayAux
          );
          return acc + (display.promised_shows * display_cpm) / 1000;
        }, 0);
        this.checkUpdateByAmountBudget(calculatedBudget);
      }

      if (isInitialLoad) {
        if (!nextProps.isPaymentStatusApproved) {
          // when create customContent (isTheFirstApply == true)
          this.updateByAmountBudget(this.props.amountBudget)
        }
      }
    }

    if (prevProps.calculatingPrices && !nextProps.calculatingPrices) {
      if (
        nextProps.pricesData &&
        (!nextProps.pricesErrors || nextProps.pricesErrors.length === 0)
      ) {
        this.setState({ stepsCurrent: STEP_SUMMARY });
      } else if (nextProps.pricesErrorStatus === 403) {
        const { user } = nextProps;
        if (user && user.company && user.company.type === 'media' && !user.company.is_verified) {
          this.showVerifiedAgencyModal(this.props.t('Unverified media company programmatic limit'));
        }
      }
    }

    this.isPaused();
  }

  createCanvaDesign = () => {
    this.handleCanvaClose();
    this.props.canva.createDesign({
      design: {
        type: 'Poster',
        dimensions: {
          width: this.state.width ? this.state.width : 300,
          height: this.state.height ? this.state.height : 300,
          units: 'px'
        }
      },
      onDesignOpen: ({ designId }) => {
        // Triggered when editor finishes loading and opens a new design.
        // You can save designId for future use.
      },
      onDesignPublish: ({ exportUrl, designId }) => {
        // Triggered when design is published to an image.
        // Save the image to your server as the exportUrl will expire shortly.
        var blob = null;
        var xhr = new XMLHttpRequest();
        xhr.open('GET', exportUrl);
        xhr.responseType = 'blob'; //force the HTTP response, response-type header to be blob
        xhr.onload = () => {
          blob = xhr.response; //xhr.response is now a blob object
          setTimeout(() => {
            blob.lastModifiedDate = new Date();
            blob.name = 'Diseño en canva';
            blob.canva_id = designId;
            blob.file = blob;
            this.setState({
              uploadingFile: true
            });
            this.props.uploadFileRequest(blob);
          }, 4000);
        };

        xhr.send();
      },
      onDesignClose: () => {
        // Triggered when editor is closed.
        console.log('hacer algo al cerrar');
      }
    });
  };

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  handleRulesChange = value => {
    const { rulesModalVisible } = this.state;
    this.setState({
      rulesModalVisible: !rulesModalVisible
    });
  };

  handleCanvaClose = e => {
    this.setState({
      canvaModalVisible: false
    });
  };

  handleFinalSubmit = () => {
    if (this.isUnverifiedMediaCompanyTraditionalBlock()) {
      this.showVerifiedAgencyModal(this.props.t('Unverified media company traditional limit'));
      return;
    }
    if (this.props.editCampaignActive) {
      return this.editCampaign();
    } else {
      return this.createCampaign();
    }
  };

  showCanvaModal = () => {
    this.setState({
      canvaModalVisible: true
    });
  };

  changeSubsidizedPrice = checked => {
    this.setState({
      subsidized_all: checked
    });
    this.props.updateSubsidizedPrice(null, checked, 'multiple');
  };
  changeFilter = value => {
    this.setState({
      settingFilter: value
    });
  };

  changeCategory = value => {
    this.props.setCategoriesId(value);
  };

  getCampaignSteps = (payments, creationType, isPaymentStatusApproved, t) => {
    const items = [
      { title: creationType === 'makeProposal' ? 'Your proposal' : 'Your campaign', content: 'defineInfo' },
      ...(this.isNewProposalCreation() ? [] : [{ title: 'Ad library', content: 'defineLibrary' }]),
      { title: 'Configuration', content: 'defineDisplay' },
      { title: 'Summary', content: 'summary' }
    ];

    if (creationType !== 'makeProposal' && !isPaymentStatusApproved && payments.length === 0) {
      items.push({ title: 'Make payment', content: 'payment' });
    }

    return items;
  };

  render() {
    const { errors, inputCharLimit, stepsCurrent, areaCharLimit, sideInfoCollapsed } = this.state;
    const {
      t,
      user,
      i18n,
      currentCampaign,
      customContents,
      editCampaignActive,
      editingCampaign,
      programmatic,
      isPaymentStatusApproved,
      userUpdate,
      history,
      creationType,
      setCreationType,
      payments,
      listResolutionWithContent,
      listResolutionWithPlaceholders,
      listOfContentsInCampaign,
      loadingContentsbyCompany,
      fetchingPlaceholders,
      fetchingCampaign
    } = this.props;

    const allDisplaysAreOwn =
      this.props.cart &&
      this.props.cart.every(display => {
        const isOwnDisplay =
          (display.company_id ? display.company_id : display.company.id) == user.company_id;
        const displayHoldingId = display.holding_id
          ? display.holding_id
          : display.company.holding_id;
        const isHoldingDisplay =
          user.roles.includes('holding-member') &&
          user.holding &&
          user.holding.id === displayHoldingId;
        return isOwnDisplay || isHoldingDisplay;
      });
    const displaysByAspectRatio = [];
    this.state.excessTraditionalVideoLength = false;
    this.state.excessProgrammaticVideoLength = false;

    this.props.cart.forEach(display => {
      const current = displaysByAspectRatio.find(
        d =>
          d.typeSize ===
          getSimilarAspectRatio(display.resolution_width, display.resolution_height, this.props.t)
      );
      if (
        programmatic === 'traditional' &&
        this.props.defaultContent.type === 'video' &&
        Math.floor(this.props.defaultContent.length / 1000) * 1000 > display.slot_length
      ) {
        this.state.excessTraditionalVideoLength = true;
      }
      if (
        programmatic === 'programmatic' &&
        this.props.defaultContent.type === 'video' &&
        this.props.defaultContent.length > 11000
      ) {
        this.state.excessProgrammaticVideoLength = true;
      }
      if (!current) {
        displaysByAspectRatio.push({
          aspectRatio: getAspectRatio(display.resolution_width, display.resolution_height),
          typeSize: getSimilarAspectRatio(
            display.resolution_width,
            display.resolution_height,
            this.props.t
          ),
          displays: [display]
        });
      } else {
        current.displays.push(display);
      }
    });

    const enabledRenderRules = programmatic === 'programmatic';

    const previewCampaignData = this.buildCampaignObject();

    let checkoutData = null;

    if (this.state.viewCampaignPayment) {
      checkoutData = this.props.currentCampaign;
    } else {
      checkoutData = previewCampaignData;
    }

    const stepsList = this.getCampaignSteps(payments, creationType, isPaymentStatusApproved, t);
    const isNewProposalCreation = this.isNewProposalCreation();
    const visibleStepsCurrent = !isNewProposalCreation
      ? stepsCurrent
      : stepsCurrent > STEP_LIBRARY
        ? stepsCurrent - 1
        : STEP_INFO;

    let disabledNext = false;

    if (stepsCurrent === STEP_INFO) {
      disabledNext = !editCampaignActive && !creationType;
    }

    if (stepsCurrent === STEP_LIBRARY) {
      disabledNext =
        fetchingCampaign ||
        loadingContentsbyCompany ||
        fetchingPlaceholders ||
        this.isPlaceholderListOutdated() ||
        (creationType !== 'makeProposal' && !isVersionFullyCovered(listResolutionWithContent, getRequiredVersionName(listOfContentsInCampaign)));
    }


    return (
      <ErrorBoundary
        fallbackRender={({ error }) => <CriticalErrorFallbackComponent error={error} />}
      >
        {/* Check company for user and redirect to the correct company */}
        {user.permissions.includes('switch_company') && (
          <CheckCompanyForUserComponent user={user} userUpdate={userUpdate} history={history} />
        )}
        <CampaignManagerHolder>
          {/*
            Layout responsive:
            - >= 1200px (xl/xxl): 3 columnas (3/18/3), sidebars sticky a los lados.
            - 768-1199px (md/lg): sidebars arriba en 2 columnas, contenido a ancho completo.
            - 576-767px (sm): sidebars arriba en 2 columnas angostas, contenido debajo.
            - < 576px (xs): sidebars apilados a ancho completo (cards compactas), contenido debajo.
            Los botones Volver/Continuar pasan a una barra fija inferior por CSS en < 1200px.
          */}
          <Row
            type="flex"
            justify="center"
            className={`campaignManagerRow ${sideInfoCollapsed ? 'sideInfoCollapsed' : ''}`}
          >
            {/* Solo visible en < 1200px: colapsa/expande los sidebars */}
            <Col span={24} order={0} className="sideInfoToggleCol">
              <button
                type="button"
                className="sideInfoToggle"
                onClick={this.toggleSideInfo}
                aria-expanded={!sideInfoCollapsed}
              >
                <Icon type="info-circle" className="sideInfoToggleIcon" />
                <span className="sideInfoToggleTitle">{t('Campaign Information')}</span>
                {sideInfoCollapsed && this.renderSideInfoSummary()}
                <Icon type={sideInfoCollapsed ? 'down' : 'up'} className="sideInfoToggleChevron" />
              </button>
            </Col>
            <Col
              className="campaignManagerSide campaignManagerSideLeft"
              xs={{ span: 24, order: 1 }}
              sm={{ span: 12, order: 1 }}
              md={{ span: 12, order: 1 }}
              lg={{ span: 12, order: 1 }}
              xl={{ span: 3, order: 1 }}
              xxl={{ span: 3, order: 1 }}
            >
              <LeftSideComponent
                stepsCurrent={stepsCurrent}
                updateByAmountBudget={this.updateByAmountBudget}
                cart={this.props.cart}
                customContents={this.props.customContents}
                updateRealAmount={this.props.updateRealAmount}
                viewCampaignPayment={this.state.viewCampaignPayment}
                editCampaignActive={editCampaignActive}
                currentCampaign={currentCampaign}
                editingCampaign={this.props.editingCampaign}
                prevSteps={this.prevSteps}
                history={this.props.history}
              />
            </Col>
            <Col
              className="videoUploadContainer campaignManagerMain"
              xs={{ span: 24, order: 3 }}
              sm={{ span: 24, order: 3 }}
              md={{ span: 24, order: 3 }}
              lg={{ span: 24, order: 3 }}
              xl={{ span: 18, order: 2 }}
              xxl={{ span: 18, order: 2 }}
            >
              <Steps current={visibleStepsCurrent} className="stepsContent">
                {stepsList.map(item => (
                  <Step key={item.title} title={t(item.title)} />
                ))}
              </Steps>

              {stepsCurrent === STEP_INFO && (
                <StepInfo
                  {...this.props}
                  {...this.state}
                  setCampaignName={val => this.handleNameChange({ target: { value: val } })}
                  setCampaignDescription={val =>
                    this.handleDescriptionChange({ target: { value: val } })
                  }
                  changeSubsidizedPrice={checked => this.changeSubsidizedPrice(checked)}
                  changeCategory={this.changeCategory}
                  setIsCampaignPaused={this.handleIsCampaignsPausedToggle}
                  setIsCampaignTest={this.handleIsCampaignsTestToggle}
                  resetCampaignData={this.resetCampaignData}
                  allDisplaysAreOwn={allDisplaysAreOwn}
                />
              )}

              {stepsCurrent === STEP_LIBRARY && isNewProposalCreation && (
                <div
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    padding: 48,
                    textAlign: 'center',
                    boxShadow: 'rgba(0, 0, 0, 0.25) 1px 2px 4px 0px',
                  }}
                >
                  <Icon type="loading" style={{ fontSize: 24 }} />
                  <div style={{ marginTop: 12, color: '#888' }}>{t('Preparing your proposal...')}</div>
                </div>
              )}

              {stepsCurrent === STEP_LIBRARY && isNewProposalCreation && (
                <div style={{ position: 'absolute', opacity: 0, height: 0, overflow: 'hidden', pointerEvents: 'none' }}>
                  <LibraryStepContainer applyRelationOnScreens={this.applyRelationOnScreens} />
                </div>
              )}

              {stepsCurrent === STEP_LIBRARY && !isNewProposalCreation && (
                <LibraryStepContainer applyRelationOnScreens={this.applyRelationOnScreens} />
              )}

              {stepsCurrent === STEP_SETTINGS && (
                <StepTwo
                  enabledRenderRules={enabledRenderRules}
                  applyRelationOnScreens={this.applyRelationOnScreens}
                  allDisplaysAreOwn={allDisplaysAreOwn}
                />
              )}

              {stepsCurrent === STEP_SUMMARY && (
                <StepThree campaignData={checkoutData} />
              )}

              {stepsCurrent === STEP_PAYMENT && (
                <StepFour />
              )}
            </Col>
            <Col
              className="campaignManagerSide campaignManagerSideRight"
              xs={{ span: 24, order: 2 }}
              sm={{ span: 12, order: 2 }}
              md={{ span: 12, order: 2 }}
              lg={{ span: 12, order: 2 }}
              xl={{ span: 3, order: 3 }}
              xxl={{ span: 3, order: 3 }}
            >
              <RightSideComponent
                stepsCurrent={stepsCurrent}
                programmatic={programmatic}
                listResolutionWithContent={this.props.listResolutionWithContent}
                updateByAmountBudget={this.updateByAmountBudget}
                cart={this.props.cart}
                customContents={this.props.customContents}
                updateRealAmount={this.props.updateRealAmount}
                editCampaignActive={editCampaignActive}
                editingCampaign={editingCampaign}
                editCampaign={this.editCampaign}
                nextSteps={this.nextSteps}
                creationType={creationType}
                creatingCampaign={this.props.creatingCampaign}
                calculatingPrices={this.props.calculatingPrices}
                onFinish={this.handleFinalSubmit}
                isPaymentStatusApproved={isPaymentStatusApproved}
                payments={payments}
                disabledNext={disabledNext}
              />
            </Col>
          </Row>
          <VerifiedAgencyInfoModal
            isVisible={this.state.isVerifiedAgencyModalVisible}
            hide={this.hideVerifiedAgencyModal}
            message={this.state.verifiedAgencyModalMessage}
          ></VerifiedAgencyInfoModal>
          {!isPaymentStatusApproved && programmatic === 'programmatic' && (
            <UnderMinimumSpotsModal
              isVisible={this.state.isUnderMinimumModalVisible}
              onAdjustInvestment={this.hideUnderMinimumModal}
              onIgnore={this.handleIgnoreUnderMinimum}
              spots={this.state.underMinimumProgrammaticSpots}
              editCampaignActive={this.props.editCampaignActive}
              currentCampaign={this.props.currentCampaign}
            />
          )}
          <NewScreensWarningModal
            visible={this.state.newScreensWarningVisible}
            onClose={() => this.setState({ newScreensWarningVisible: false })}
          />
          <OptionModal
            title={t('Atention!')}
            body={t(
              'There are ads that do not match any screen and will not be saved ({{versions}}). Continue?',
              { versions: (this.state.unmatchedVersionsWarning || []).join(', ') }
            )}
            visible={!!this.state.unmatchedVersionsWarning}
            okText={t('Continue')}
            cancelText={t('Cancel')}
            onOk={this.confirmUnmatchedVersionsWarning}
            onCancel={this.cancelUnmatchedVersionsWarning}
          />
        </CampaignManagerHolder>
      </ErrorBoundary>
    );
  }
}

const Extended = withTranslation()(CampaignManagerComponent);
Extended.static = CampaignManagerComponent.static;

export default withRouter(Form.create({ name: 'CampaignManagerComponent' })(Extended));
CampaignManagerComponent.contextTypes = {
  router: PropTypes.object
};
